import * as React from 'react';
import type { SVGProps } from 'react';

export type IllustrationSizeVariants =
  | 'small'
  | 'medium'
  | 'large'
  | 'xlarge'
  | 'xxlarge'
  | 'xxxlarge'
  | 'xxxxlarge';
export type IllustrationProps = {
  width?: number | string;
  height?: number | string;
  size?: IllustrationSizeVariants;
};
const IllustrationSpotVisitor = ({
  size = 'medium',
  width,
  height,
  ...props
}: IllustrationProps) => {
  let presetWidth: string | undefined;
  let presetHeight: string | undefined;
  const presets = {
    small: '48px',
    medium: '68px',
    large: '92px',
    xlarge: '122px',
    xxlarge: '156px',
    xxxlarge: '194px',
    xxxxlarge: '236px',
  };
  if (size) {
    presetWidth = presets[size];
    presetHeight = presets[size];
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 68 68"
      data-xds="IllustrationSpotVisitor"
      height={height || presetHeight}
      role="presentation"
      width={width || presetWidth}
      {...props}
    >
      <path
        fill="var(--xdlColorIllustrationBackground)"
        d="M62.83 32.66c-.94-.81-2.12-1.24-3.42-1.24h-.33c.63-5.27-.63-8.37-3.77-9.22a5 5 0 0 0-1.34-.18c-.78 0-1.54.17-2.26.51l.68-5.04a5.708 5.708 0 0 0-5.66-6.55c-1.39 0-2.69.5-3.7 1.36l.19-3.57a5.72 5.72 0 0 0-5.07-6.03c-.22-.02-.44-.04-.65-.04-2.81 0-5.18 2.03-5.63 4.83v.07l-.05.43a5.86 5.86 0 0 0-4.22-1.86c-.73 0-1.46.14-2.13.42a5.7 5.7 0 0 0-3.43-1.14 5.9 5.9 0 0 0-1.86.31c-2.88.99-4.47 4.07-3.62 7.02l.02.06.14.39c-.08-.03-.17-.05-.26-.08l-3.42-8.88-4.67 1.8 1.6 4.17-4.74-5.09-3.66 3.41 4.95 5.32-2.57-1.57-2.61 4.27 7.52 4.59.36-.58v.02l2.49 6.6c-.21-.02-.42-.04-.63-.04-.97 0-1.93.25-2.77.72-2.66 1.48-3.7 4.78-2.37 7.48l9.05 19.11c3.45 6.92 10.69 11.4 18.45 11.4 2.27 0 4.5-.37 6.65-1.11l1.98-.68c3.22-1.11 6.37-3.37 8.88-6.37.51-.54.95-1.04 1.36-1.56l.06-.08c1.72-2.28 7.47-9.89 9-12.05 3.67-5.17 4.16-8.98 1.46-11.3z"
      />
      <path
        fill="#fff"
        d="m34.17 32.26-3.42-16.99c-.33-1.68.72-3.32 2.38-3.74 1.66-.41 3.36.55 3.86 2.19l7.97 25.05s2.69-6.69 4.55-10.21c1.74-3.29 3.53-4.37 5.14-3.93 2.64.72 2.25 4.98 1.72 7.99-.52 2.95-2.98 14.78-2.98 14.78-1.38 6.11-6.21 12.24-12.13 14.28l-1.98.68c-8.58 2.95-18.01-.92-22.05-9.04L8.2 34.25a3.22 3.22 0 0 1 1.33-4.23 3.22 3.22 0 0 1 4.29 1.11l5.2 8.28-7.45-19.74a3.222 3.222 0 0 1 5.86-2.66l9.9 18.16-8.37-23.16a3.22 3.22 0 0 1 2.05-3.93c1.62-.56 3.39.25 4.03 1.84l9.15 22.34z"
      />
      <path
        fill="var(--xdlColorIllustrationOutlinePrimary)"
        fillRule="evenodd"
        d="M33.82 7.82c.33-1.98 2.12-3.35 4.09-3.12 1.97.22 3.42 1.94 3.3 3.92l-.77 14.32.5 1.56 2.18-8.75c.49-1.92 2.4-3.12 4.34-2.73s3.23 2.23 2.94 4.19l-1.56 11.56c.08-.15.16-.31.23-.45 2.19-4.15 4.31-4.56 5.71-4.18 3.42.94 2.41 6.68 2.08 8.56-.07.38-.17.91-.29 1.55 2.52-1.29 4.07-.83 4.95-.07l-.02.02c2.7 2.32-.67 7.07-1.78 8.63C58 45.25 50.76 54.82 50.69 54.92c-.39.49-.81.96-1.25 1.42-2.23 2.69-5.04 4.79-8.04 5.82l-1.98.68c-1.98.68-4 1-6 1-6.88 0-13.45-3.85-16.66-10.29L7.73 34.47a3.72 3.72 0 0 1 6.5-3.6l.36.57v-2.32l-3.5-9.27c-.72-1.84.13-3.92 1.93-4.74 1.81-.82 3.93-.08 4.84 1.68l1.65 3.03c1.32.45 2.33 1.61 2.5 3.08l.23 1.91.5.91.12-1.44-4.38-12.1c-.56-1.93.48-3.93 2.35-4.57 1.64-.57 3.41.08 4.32 1.48.65-.59 1.5-.96 2.44-.96h.06a3.72 3.72 0 0 1 3.65 3.59l.02.27c.45-.44 1.02-.79 1.68-.95.17-.05.35-.06.52-.08zm-9.25 2.3a2.723 2.723 0 0 0-3.41-1.56 2.717 2.717 0 0 0-1.73 3.32l8.36 23.13-.91.41-9.9-18.16a2.71 2.71 0 0 0-3.54-1.24c-1.32.6-1.94 2.12-1.41 3.47l7.46 19.74-.89.44-5.2-8.28c-.52-.82-1.4-1.28-2.31-1.28a2.715 2.715 0 0 0-2.44 3.91l9.03 19.07c3.92 7.86 13.13 11.64 21.44 8.78v.01l1.98-.68c5.53-1.91 10.39-7.63 11.81-13.92.036-.13 2.471-11.844 2.98-14.75.79-4.46.33-6.96-1.36-7.42-1.9-.53-3.53 1.72-4.57 3.68-1.83 3.46-4.5 10.09-4.53 10.16l-.52 1.29-8.39-26.37a2.72 2.72 0 0 0-3.26-1.85c-1.4.35-2.29 1.74-2.01 3.16l3.42 16.99-.95.29z"
        clipRule="evenodd"
      />
      <path
        fill="var(--xdlColorIllustrationOutlinePrimary)"
        d="m8.723 17.515-.522.853-4.104-2.507.521-.854zM11.16 14.418l-.731.682-6.03-6.479.733-.681zM14.176 12.751l-.934.36-2.28-5.927.934-.36z"
      />
    </svg>
  );
};
export default IllustrationSpotVisitor;
